import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux'
import queryString from 'query-string';
import config from 'src/config'
import { domain, domainConfig, getPromo } from 'src/helpers/domainConfig'

class Terms extends React.Component {
  render() {   
    let title = domainConfig.title;
    let url = location.protocol+"//"+location.host;
    return (
      <div class="terms container p-5" lang="EN-US" link="blue" vlink="purple"> 
        <div class="Section1">
          <h5 class="text-center">Terms of Service</h5>
          <p>
            If you require any more information or have any questions about our Terms of Service, 
            please feel free to contact us using our live chat at {url}.          
          </p> 
          <div>
            <h6>Introduction</h6>
            <p>            
              These terms and conditions govern your use of "Service" 
              ({url} website ("website") and any applicable Software collectively, the "Service") 
              and all products and services offered by {title}; 
              by using this Service, you accept these terms and conditions in full and without reservation. 
              If you disagree with these terms and conditions or any part of these terms and conditions, 
              you must not use this Service.              
            </p>
            <p>
              You must be at least 13 years of age to use this Service. 
              By using this Service and by agreeing to these terms and conditions, 
              you warrant and represent that you are at least 13 years of age.
            </p> 
          </div>
          <div>
            <h6>License to use the Service</h6>
            <p>            
              Unless otherwise stated, Service and/or its licensors own the intellectual property rights 
              published on this Service and materials used on {url}. 
              Subject to the license below, all these intellectual property rights are reserved.
            </p> 
            <p>
              You may view, download for caching purposes only, and print pages, files or other content 
              from the Service for your own personal use, 
              subject to the restrictions set out below and elsewhere in these terms and conditions.
            </p>
            <p>
              You must not:
            </p>
            <ul>
              <li>
                sell, rent or sub-license material from the Service;
              </li>
              <li>
                reproduce, duplicate, copy or otherwise exploit material on this Service for a commercial purpose;
              </li>
              <li>
                edit or otherwise modify any material on the Service;
              </li>
              <li>
                redistribute material from this Service - except for content specifically and expressly made available for redistribution; or
              </li>
              <li>
                republish or reproduce any part of this Service through the use of iframes or screenscrapers.
              </li>
            </ul>                            
          </div>
          <div>
            <h6>Acceptable use</h6>
            <p>            
              You must not use this Service in any way that causes, or may cause, damage to the Service 
              or impairment of the availability or accessibility of {title} or in any way which is unlawful, 
              illegal, fraudulent or harmful, or in connection with any unlawful, illegal, 
              fraudulent or harmful purpose or activity.
            </p> 
            <p>
              You must not use this Service to copy, store, host, transmit, send, use, 
              publish or distribute any material which consists of (or is linked to) any spyware, computer virus, 
              Trojan horse, worm, keystroke logger, rootkit or other malicious computer software.
            </p>            
            <p>
              You must not conduct any systematic or automated data collection activities on or in relation 
              to this Service without {title}'s express written consent.              
            </p>
            <p>
              This includes:
            </p>
            <ul>
              <li>
                scraping
              </li>
              <li>
                data mining
              </li>
              <li>
                data extraction
              </li>
              <li>
                data harvesting
              </li>
              <li>
                'framing' (iframes)
              </li>
              <li>
                Article 'Spinning'
              </li>
            </ul>
            <p>
              You must not use this Service or any part of it to transmit or send unsolicited commercial communications.
            </p>
            <p>
              You must not use this Service for any purposes related to marketing without the express written consent of {title}.
            </p>                                                                                    
          </div>
          <div>
            <h6>Restricted access</h6>        
            <p>           
              Access to certain areas of this Service is restricted. 
              {title} reserves the right to restrict access to certain areas of this Service, 
              or at our discretion, this entire Service. {title} may change or modify this policy without notice.         
            </p> 
            <p>
              If {title} provides you with a user ID and password to enable you to access restricted areas of this Service 
              or other content or services, you must ensure that the user ID and password are kept confidential. 
              You alone are responsible for your password and user ID security.
            </p>
            <p>
              {title} may disable your user ID and password at {title}'s sole discretion without notice or explanation.
            </p>
          </div>
          <div>
            <h6>User content</h6>
            <p>              
              In these terms and conditions, "your user content" means material 
              (including without limitation text, images, audio material, video material and audio-visual material) 
              that you submit to this Service, for whatever purpose.
            </p> 
            <p>              
              Your user content must not be illegal or unlawful, must not infringe any third party's legal rights, 
              and must not be capable of giving rise to legal action whether against you or {title} or a third party 
              (in each case under any applicable law).
            </p> 
            <p>              
              You must not submit any user content to the Service that is or has ever been the subject of any threatened 
              or actual legal proceedings or other similar complaint.
            </p> 
            <p>              
              {title} reserves the right to edit or remove any material submitted to this Service, 
              or stored on the servers of {title}, or hosted or published upon this website.
            </p> 
            <p>              
              {title}'s rights under these terms and conditions in relation to user content, 
              {title} does not undertake to monitor the submission of such content to, 
              or the publication of such content on, this Service.
            </p>                                                 
          </div> 

          <div>
            <h6>No warranties</h6>
            <p>            
              This Service is provided “as is” without any representations or warranties, express or implied. 
              {title} makes no representations or warranties in relation to this Service 
              or the information and materials provided on this Service.
            </p> 
            <p>
              Without prejudice to the generality of the foregoing paragraph, {title} does not warrant that:
            </p>            
            <ul>
              <li>
                this Service will be constantly available, or available at all; or
              </li>
              <li>
                the information on this Service is complete, true, accurate or non-misleading.
              </li>
            </ul>
            <p>
              Nothing on this Service constitutes, or is meant to constitute, advice of any kind. 
              If you require advice in relation to any legal, financial or medical matter 
              you should consult an appropriate professional.
            </p>                                                                                   
          </div>

          <div>
            <h6>Limitations of liability</h6>
            <p>            
              {title} will not be liable to you (whether under the law of contact, the law of torts or otherwise) 
              in relation to the contents of, or use of, or otherwise in connection with, this Service:
            </p> 
            <ul>
              <li>
                to the extent that the Service is provided free-of-charge, for any direct loss;
              </li>
              <li>
                for any indirect, special or consequential loss; or
              </li>
              <li>
                for any business losses, loss of revenue, income, profits or anticipated savings, 
                loss of contracts or business relationships, loss of reputation or goodwill, 
                or loss or corruption of information or data.
              </li>
            </ul>
            <p>
              These limitations of liability apply even if {title} has been expressly advised of the potential loss.
            </p>                                                                                    
          </div>

          <div>
            <h6>Exceptions</h6>
            <p>            
              Nothing in this Service disclaimer will exclude or limit any warranty implied by law 
              that it would be unlawful to exclude or limit; 
              and nothing in this Service disclaimer will exclude or limit the liability of {title} in respect of any:
            </p> 
            <ul>
              <li>
                death or personal injury caused by the negligence of {title} or its agents, employees or shareholders/owners;
              </li>
              <li>
                fraud or fraudulent misrepresentation on the part of {title}; or
              </li>
              <li>
                matter which it would be illegal or unlawful for {title} to exclude or limit, 
                or to attempt or purport to exclude or limit, its liability.
              </li>
            </ul>                                                                                   
          </div>  

          <div>
            <h6>Reasonableness</h6>        
            <p>           
             By using this Service, you agree that the exclusions and limitations of liability 
             set out in this Service disclaimer are reasonable.
            </p> 
            <p>
              If you do not think they are reasonable, you must not use this Service.
            </p>
          </div>   

          <div>
            <h6>Other parties</h6>        
            <p>           
             You accept that, as a limited liability entity, {title} has an interest in limiting the personal liability 
             of its officers and employees. 
             You agree that you will not bring any claim personally against {title}'s officers or employees 
             in respect of any losses you suffer in connection with the website.
            </p> 
            <p>
              Without prejudice to the foregoing paragraph, you agree that the limitations of warranties 
              and liability set out in this Service disclaimer will protect {title}'s officers, employees, 
              agents, subsidiaries, successors, assigns and sub-contractors as well as {title}.
            </p>
          </div>  

          <div>
            <h6>Unenforceable provisions</h6>        
            <p>           
             If any provision of this website disclaimer is, or is found to be, unenforceable under applicable law, 
             that will not affect the enforceability of the other provisions of this Service disclaimer.
            </p> 
          </div>  

          <div>
            <h6>Indemnity</h6>        
            <p>           
              You hereby indemnify {title} and undertake to keep {title} indemnified against any losses, damages, costs, 
              liabilities and expenses (including without limitation legal expenses and any amounts paid by {title} 
              to a third party in settlement of a claim or dispute on the advice of {title}'s legal advisers) 
              incurred or suffered by {title} arising out of any breach by you of any provision of these terms and conditions, 
              or arising out of any claim that you have breached any provision of these terms and conditions.
            </p> 
          </div>  

          <div>
            <h6>Breaches of these terms and conditions</h6>        
            <p>           
              Without prejudice to {title}'s other rights under these terms and conditions, 
              if you breach these terms and conditions in any way, 
                {title} may take such action as {title} deems appropriate to deal with the breach, 
              including suspending your access to the Service, prohibiting you from accessing the Service, 
              blocking computers using your IP address from accessing the Service, 
              contacting your internet service provider to request that they block your access to the website 
              and/or bringing court proceedings against you.       
            </p> 
          </div>  

          <div>
            <h6>Variation</h6>        
            <p>           
             {title} may revise these terms and conditions from time-to-time. 
             Revised terms and conditions will apply to the use of this Service from the date of the publication 
             of the revised terms and conditions on this Service. 
             Please check this page regularly to ensure you are familiar with the current version.
            </p> 
          </div>  

          <div>
            <h6>Assignment</h6>        
            <p>           
              {title} may transfer, sub-contract or otherwise deal with {title}'s rights and/or obligations 
              under these terms and conditions without notifying you or obtaining your consent.
            </p> 
            <p>
              You may not transfer, sub-contract or otherwise deal with your rights and/or obligations 
              under these terms and conditions.
            </p>
          </div>  

          <div>
            <h6>Severability</h6>        
            <p>           
              If a provision of these terms and conditions is determined by any court or other competent authority 
              to be unlawful and/or unenforceable, the other provisions will continue in effect. 
              If any unlawful and/or unenforceable provision would be lawful or enforceable if part of it were deleted, 
              that part will be deemed to be deleted, and the rest of the provision will continue in effect.       
            </p> 
          </div>  

          <div>
            <h6>Entire agreement</h6>        
            <p>           
              These terms and conditions, together with {title}'s Privacy Policy constitute the entire agreement 
              between you and {title} in relation to your use of this Service, 
              and supersede all previous agreements in respect of your use of this Service.       
            </p> 
          </div>  

          <div>
            <h6>Law and jurisdiction</h6>        
            <p>           
              These terms and conditions will be governed by and construed in accordance with the laws of USA, 
              and any disputes relating to these terms and conditions will be subject to the exclusive jurisdiction 
              of the courts of USA.       
            </p> 
          </div>     

          <div>  
            <p>
              <i>This document was last updated on February 14, 2018</i>
            </p>                                                                                     
          </div>                                                                                                                                   

        </div> 
      </div> 
    )
  }
}
export default Terms;